import { Action } from '@ngrx/store'
import { PoUpload } from '../../../models'

export const PURCHASE_ORDER_UPLOAD = '[Purchase Order Upload] Purchase Order Upload'
export const PURCHASE_ORDER_UPLOAD_SUCCESS = '[Purchase Order Upload] Purchase Order Upload Success'
export const PURCHASE_ORDER_UPLOAD_FAIL = '[Purchase Order Upload] Purchase Order Upload Fail'

export class PurchaseOrderUpload implements Action {
  readonly type = PURCHASE_ORDER_UPLOAD

  constructor (public payload: { form: PoUpload }) { }
}

export class PurchaseOrderUploadSuccess implements Action {
  readonly type = PURCHASE_ORDER_UPLOAD_SUCCESS
  constructor (public payload: any) { }
}

export class PurchaseOrderUploadFail implements Action {
  readonly type = PURCHASE_ORDER_UPLOAD_FAIL
  constructor (public payload: any) { }
}
